import * as React from 'react'
import { Box, Typography } from '@mui/material'

import { NotAllowedBlock } from '@components'


export default function lastReviewRatingColumn() {
	return {
		name: "lastReviewRating", label: "Last Review Rating",
		options: {
			filter: false,
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Box sx={{ display: 'flex', alignItems: 'center'}}>
				{!!value && <Typography>
					{value}
				</Typography>}

				{!value && <NotAllowedBlock />}
			</Box> 
		}
	}
}